module.exports = __webpack_public_path__ + "img/shop_banner.4b4dceb5.png";